export default __webpack_public_path__ + "static/welcome-6591595ad7ec21aed26a614ca4fb6c2b.png";